import React from "react";
import styles from "../../../pages/ask/price.module.less";
/** 麵包屑 */
const Crumbs = (props: { title?: string; b: string; k: string; brandName?: string; kindName?: string }) => {
  const { b, k, brandName, kindName, title } = props;
  return (
    <div className={styles["crumbs"]}>
      您當前的位置：新車首頁{">"}
      <a href='/Models'>車款</a>
      {">"}
      <a href={`/photoModel-brandList.html?b=${b}`}>{brandName}</a>
      {">"}
      <a href={`/photoModel-info.html?k=${k}`}>{kindName}</a>
      {">"}
      {title || '車款詢價'}
    </div>
  );
};

export default Crumbs;
